import React from "react";
import '../styles/CaseStudies.css'; // CSS for styling
import bullfrogLogoSmall from '../assets/bullfrog-logo-small.png';
import hawxLogoSmall from '../assets/hawx-logo-small.png';
import volkenLogoSmall from '../assets/volken-logo-small.png';
import aiCallTracking from '../assets/ai-call-tracking.png';
import decreasedCpl from '../assets/decreased-cpl.png';
import increasedRoi from '../assets/increased-roi.png';
import sunIcon from '../assets/sun.png'; // Replace with the actual image path if applicable
import { Link, useNavigate } from 'react-router-dom';

const CaseStudies = () => {

  const navigate = useNavigate();

  const handleCaseStudyOneClick = () => {
    navigate('/case-studies-one');
    setTimeout(() => {
      const heroElement = document.getElementById('case-studies-hero-one');
      if (heroElement) {
        heroElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100); // Wait for navigation to complete
  };

  const handleCaseStudyTwoClick = () => {
    navigate('/case-studies-two');
    setTimeout(() => {
      const heroElement = document.getElementById('case-studies-hero-two');
      if (heroElement) {
        heroElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100); // Wait for navigation to complete
  };

  const handleCaseStudyThreeClick = () => {
    navigate('/case-studies-three');
    setTimeout(() => {
      const heroElement = document.getElementById('case-studies-hero-three');
      if (heroElement) {
        heroElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100); // Wait for navigation to complete
  };

  return (
    <section className="section-container2"  id="case-studies-section">
      <div className="results">
        <div className="results-title">
          <h2>
            <span className="main-text">Our Proven</span>
            <span className="highlight">RESULTS
            <span className="cmo-icon-wrapper">
                <img src={sunIcon} id="sunIcon" alt="Sun Icon" />
            </span>
            </span>
          </h2>
        </div>

        {/* Case Study Boxes */}
        <div className="case-studies-container">
          <div className="case-study-box">
            {/* Left Content */}
            <div className="case-study-content">
              <img src={bullfrogLogoSmall} alt="Bullfrog Logo" className="case-study-image" />
                <h3>Bullfrog Pool Tile Cleaning</h3>
                <div className="tags">
                  <span>Call Tracking AI</span>
                  <span>Performance Max</span>
                  <span>Google Search</span>
                </div>
                <p>
                  Bullfrog Pool Tile Cleaning reduced appointment costs to $74-$136 by using Call Tracking Metrics’ ASKAI feature and optimizing Google PMAX campaigns.
                </p>
                <button onClick={handleCaseStudyOneClick} className="case-study-button">Go To Case Study</button>
              </div>

            {/* Right Image */}
            <div className="case-study-image-placeholder">
              <img src={aiCallTracking} alt="Call Tracking AI" />
            </div>
          </div>

          <div className="case-study-box">
            {/* Left Content */}
            <div className="case-study-content">
              <img src={volkenLogoSmall} alt="Case Study Placeholder" className="case-study-image" />
                <h3>John Volken Academy Movers</h3>
                <div className="tags">
                  <span>End-to-End Tracking</span>
                  <span>Google Ads</span>
                  <span>Salesforce Integration</span>
                </div>
                <p>
                  John Volken Academy reduced customer acquisition cost from $383 to $163 using proper data optimization through a Salesforce integration.
                </p>
                <button onClick={handleCaseStudyTwoClick} className="case-study-button">Go To Case Study</button>
              </div>

            {/* Right Image */}
            <div className="case-study-image-placeholder">
              <img src={increasedRoi} alt="Placeholder" />
            </div>
          </div>

          <div className="case-study-box">
            {/* Left Content */}
            <div className="case-study-content">
              <img src={hawxLogoSmall} alt="Case Study Placeholder" className="case-study-image" />
                <h3>Hawx Pest Control</h3>
                <div className="tags">
                  <span>Audience Optimization</span>
                  <span>Sales Optimization</span>
                  <span>Google Ads</span>
                </div>
                <p>
                  Hawx Pest Control decreased their cost per lead from $194.81 to $48.53 by using audience targeting to make sure the correct customers were seeing our ads. 
                </p>
                <button onClick={handleCaseStudyThreeClick} className="case-study-button">Go To Case Study</button>
              </div>

            {/* Right Image */}
            <div className="case-study-image-placeholder">
              <img src={decreasedCpl} alt="Placeholder" />
            </div>
          </div>
        </div>

        

        {/* Call-to-Action Button */}
        <div className="results-cta">
        <p className="cta-text">
            Click below to Schedule Your FREE Growth Audit!
        </p>
          <Link to="/lead-form" className="home-page-case-studies-cta-button">Get Started</Link>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
